import React from 'react';
import styled from 'styled-components';
import { Rooms, Booking } from '../components';

const PageContainer = styled.div`
  padding-top: 80px; /* Space for fixed header */
`;

const PageHeader = styled.div`
  background-color: #1e3a8a;
  color: white;
  padding: 4rem 2rem;
  text-align: center;
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  font-family: 'Playfair Display', serif;
`;

const PageDescription = styled.p`
  max-width: 800px;
  margin: 0 auto;
  font-size: 1.1rem;
  line-height: 1.6;
`;

const RoomsPage = () => {
  return (
    <PageContainer>
      <PageHeader>
        <PageTitle>Our Rooms & Cottages</PageTitle>
        <PageDescription>
          Experience luxury and comfort with our thoughtfully designed accommodations.
          Each room and cottage offers a perfect blend of modern amenities and traditional charm,
          ensuring a memorable stay at Lakeside Haven.
        </PageDescription>
      </PageHeader>
      
      <Rooms />
      <Booking />
    </PageContainer>
  );
};

export default RoomsPage;
